import React, { useEffect, useState } from "react";
import "../styles/App.scss";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Control from "./Control";
import Map from "./Map";
import Linkouts from "./Linkouts";
import Table from "./Table";
import { makeData } from "../util/dataUtil";

const data: [] = require("../data/final.json");
const cats: Record<string, any> = require("../data/categories.json");

type SelectedOptions = Record<string, [string, string[]]>;

const App: React.FC = () => {
  const initSelectedOptions: SelectedOptions = {};

  function findAvailableValuesForSelector(
    cat: string,
    demographicSelected = Object.keys(cats["Demographics"])[0]
  ): string[] {
    let availableOptions: string[] = Array.isArray(cats[cat])
      ? cats[cat]
      : cat === "Variable"
      ? cats["Demographics"][demographicSelected]
      : Object.keys(cats[cat]);

    return availableOptions;
  }

  ["Geography", "Immigrant status", "Demographics", "Variable"].forEach(
    (cat) => {
      let availableOptions = findAvailableValuesForSelector(cat);

      initSelectedOptions[cat] = [availableOptions[0], availableOptions];
    }
  );

  const [selectedOptions, setSelectedOptions] = useState(initSelectedOptions);

  const setOption = (cat: string, newValue: string) => {
    var newSelectedOptions: SelectedOptions = JSON.parse(
      JSON.stringify(selectedOptions)
    );

    // if it's one of the "geography" or "immmigrant status" or "variable" dropdowns,
    // a simple change to the selected value does the trick
    if (
      cat === "Geography" ||
      cat === "Immigrant status" ||
      cat === "Variable"
    ) {
      newSelectedOptions[cat] = [newValue, newSelectedOptions[cat][1]];
    }

    // if the dropdown where the change has happened is demographics, the "variable" dropdown has to be repopulated
    else {
      newSelectedOptions[cat] = [newValue, newSelectedOptions[cat][1]];
      var newVariableOptions: string[] = findAvailableValuesForSelector(
        "Variable",
        newValue
      );
      newSelectedOptions["Variable"] = [
        newVariableOptions[0],
        newVariableOptions,
      ];
    }

    setSelectedOptions(newSelectedOptions);
  };

  const [[mapData, colorStops], [tableHeaders, tableData]] = makeData(
    data,
    selectedOptions
  );

  // controlled tabs to pass down selected tab id
  // to the control component to hide/show selectors
  const [tabIndex, setTabIndex] = useState(0);
  const tabOrder = ["table", "map"];

  return (
    <div id="app-container">
      <Linkouts></Linkouts>
      <Tabs
        forceRenderTabPanel={true}
        selectedIndex={tabIndex}
        onSelect={(index) => {
          setTabIndex(index);
        }}
      >
        <TabList>
          <div>
            <Tab>Table</Tab>
            <Tab>Map</Tab>
          </div>
        </TabList>
        <Control
          selectedOptions={selectedOptions}
          setOption={setOption}
          activeTab={tabOrder[tabIndex]}
        ></Control>

        <TabPanel>
          <Table tableHeaders={tableHeaders} tableData={tableData}></Table>
        </TabPanel>
        <TabPanel>
          <Map
            data={mapData}
            selectedOptions={selectedOptions}
            colorStops={colorStops}
          ></Map>
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default App;
